import { ApolloProvider } from '@apollo/client';
import PropTypes from 'prop-types';
import React from 'react';
import useApolloClient from './useApolloClient';

export const ApolloClientProvider = ({ children }) => {
  const apolloClient = useApolloClient();

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};

ApolloClientProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
